import { TaxSuggestionQuery, TaxSuggestionResponse } from "@builder/types/TaxSuggestion.type";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";

const TAX_TABLES_PATH = `tax-tables`;

export const taxApi = createApi({
    reducerPath: "taxApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${import.meta.env.VITE_URL_HUB_API}${TAX_TABLES_PATH}`,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["tax"],
    endpoints: builder => ({
        suggestTaxRate: builder.query<TaxSuggestionResponse, { companyId: string; taxSuggestionQuery: TaxSuggestionQuery }>({
            query: ({ companyId, taxSuggestionQuery }) =>
                `suggest-tax-rate/${companyId}?country=${taxSuggestionQuery.country}${
                    taxSuggestionQuery.state ? `&state=${taxSuggestionQuery.state}` : ""
                }`
        })
    })
});

export const { useLazySuggestTaxRateQuery } = taxApi;
